import React, { useState, useEffect, useRef } from 'react';
import { generateScramble } from './wordScrambleLogic';
import html2canvas from 'html2canvas'; // ضروري يكون مستورد

const WordScrambleBoard = ({ onAddToBook, seed = null }) => {
  const [puzzles, setPuzzles] = useState([]);
  const [currentSeed, setCurrentSeed] = useState(seed || Date.now().toString());
  const [showSolution, setShowSolution] = useState(false);
  const printRef = useRef(null);

  const createGame = (newSeed = null) => {
    const s = newSeed || currentSeed;
    if (newSeed) setCurrentSeed(newSeed);
    const data = generateScramble(8, null, s);
    setPuzzles(data);
    setShowSolution(false);
  };

  useEffect(() => { createGame(); }, [seed]);

  const handleNewGame = () => {
    const newS = Date.now().toString();
    createGame(newS);
  };

  // ✅✅✅ التصحيح هنا: استعمال html2canvas
  const handleAddToBook = () => {
    if (printRef.current) {
      const wasShowing = showSolution;
      setShowSolution(false); // نخبيو الحل

      // نتسناو شوية باش React يطبق الإخفاء، عاد نصورو
      setTimeout(() => {
        html2canvas(printRef.current).then((canvas) => {
           const imgData = canvas.toDataURL('image/png');
           onAddToBook('WordScramble', imgData, { seed: currentSeed });
           
           if(wasShowing) setShowSolution(true); // نرجعو الحل
        });
      }, 100);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
      <h2 style={{ color: '#2d3436' }}>Word Scramble 🌪️</h2>
      
      {!seed && (
        <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
          <button onClick={handleNewGame} style={{ background: '#6c5ce7', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer'}}>🔄 New</button>
          <button onClick={() => setShowSolution(!showSolution)} style={{ background: showSolution?'#e17055':'#00b894', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer'}}>
             {showSolution ? 'Hide' : 'Solution'}
          </button>
          <button onClick={handleAddToBook} style={{ background: '#e67e22', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer'}}>📖 Add</button>
        </div>
      )}

      <div ref={printRef} style={{ padding: '40px', background: 'white', width:'500px', border: seed?'none':'1px solid #ddd' }}>
        <h3 style={{textAlign:'center', marginBottom:'30px', fontFamily:'Courier New'}}>Unscramble the Words!</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {puzzles.map((p, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px dashed #ccc', paddingBottom: '10px' }}>
              <span style={{ fontSize: '24px', fontFamily: 'monospace', letterSpacing: '3px', fontWeight: 'bold' }}>{p.scrambled}</span>
              <span style={{ fontSize: '20px', color: showSolution ? '#d63031' : '#b2bec3', fontWeight: 'bold', minWidth: '150px', textAlign: 'right' }}>
                {showSolution ? p.original : '__________'}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default WordScrambleBoard;